import type { TButtonDefault } from "types/buttons.type"
import style from "./ButtonPrimary.module.scss"

const { button, success } = style

type Props = TButtonDefault & { variant?: "primary" | "success" }

export const ButtonPrimary = ({ children, className = "", submittable = true, onClick, variant = "primary" }: Props) => {
	return (
		<button
			onClick={onClick}
			className={`${button} ${variant === "success" ? success : ""} ${className}`}
			disabled={!submittable}
			data-testid="button-primary"
		>
			{children}
		</button>
	)
}
